import { render, staticRenderFns } from "./ListEsperaRepartidor.vue?vue&type=template&id=8d62c7c2&scoped=true"
import script from "./ListEsperaRepartidor.vue?vue&type=script&lang=js"
export * from "./ListEsperaRepartidor.vue?vue&type=script&lang=js"
import style0 from "./ListEsperaRepartidor.vue?vue&type=style&index=0&id=8d62c7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d62c7c2",
  null
  
)

export default component.exports